import './Table.css'

import { SHELL_TEST_COLUMNS, SHELL_TEST_ROWS } from '~/test-data/shell'

export const ShellTestTable = () => (
  <div className="shell-test-table-wrapper">
    <table className="shell-test-table">
      <thead>
        <tr>
          {SHELL_TEST_COLUMNS.map((col) => (
            <th key={col}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {SHELL_TEST_ROWS.map((row) => (
          <tr key={row.id}>
            <td>{row.id}</td>
            <td>{row.name}</td>
            <td>{row.status}</td>
            <td>{row.value}</td>
            {SHELL_TEST_COLUMNS.slice(4).map((col) => (
              <td key={col} className="muted">
                —
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
